'use client';

import { LocalStorage } from '@vectord/utils';
import { useEffect, useMemo, useState } from 'react';

import { ThemeContext } from '../context';
import type { Theme } from '../types/theme';
import { setWindowTheme } from '../utils';

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ls = LocalStorage.getInstance('ls-theme');

export default function ThemeProvider({ children }: ThemeProviderProps) {
  const [theme, setTheme] = useState<Theme>(ls?.theme || 'dark');

  const value = useMemo(() => ({ theme, setTheme }), [theme]);

  useEffect(() => {
    setWindowTheme(theme);
    ls.theme = theme;
  }, [theme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}
